var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 504 504",
    style: {
      enableBackground: "new 0 0 504 504"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#324A5E"
    },
    cx: 252,
    cy: 252,
    r: 252
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2B3B4E"
    },
    d: "M33.9,378.1C77.5,453.4,158.8,504,252,504s174.5-50.6,218.1-125.9H33.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFD05B"
    },
    points: "394.8,379.4 398.3,348.9 360.3,348.9 363.8,379.4  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FFD05B"
    },
    points: "213.7,379.4 217.2,348.9 179.2,348.9 182.7,379.4  "
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FF7058"
    },
    d: "M394.1,294.4H183.4V159.8c0-4.5,3.6-8.1,8.1-8.1H386c4.5,0,8.1,3.6,8.1,8.1V294.4z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F1543F"
    },
    d: "M432.5,238.2v89.7c0,17.4-14.1,31.5-31.5,31.5H176.5c-17.4,0-31.5-14.1-31.5-31.5v-89.7 c0-14.1,11.5-25.6,25.6-25.6l0,0c14.1,0,25.6,11.5,25.6,25.6V293h185.2v-54.8c0-14.1,11.5-25.6,25.6-25.6l0,0 C421.1,212.6,432.5,224.1,432.5,238.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F1543F"
    },
    d: "M328.2,190.6c-0.7,0.3-1.6,0.8-2.7,1.5c-0.3,0.2-0.5,0.3-0.8,0.5c-2.7,1.8-6.2,1.8-9,0 c-0.3-0.2-0.6-0.4-0.8-0.5c-1-0.7-2-1.1-2.7-1.4c-0.7-0.3-1.1-0.5-1.1-0.5s0.1,0.4,0.5,1.1c0.3,0.7,0.8,1.6,1.4,2.7 c0.2,0.3,0.3,0.6,0.5,0.8c1.8,2.7,1.8,6.2,0,9c-0.2,0.3-0.4,0.6-0.5,0.8c-0.7,1-1.1,2-1.4,2.7s-0.5,1.1-0.5,1.1s0.4-0.1,1.1-0.5 c0.7-0.3,1.6-0.8,2.7-1.4c0.3-0.2,0.6-0.3,0.8-0.5c2.7-1.8,6.2-1.8,9,0c0.3,0.2,0.6,0.4,0.8,0.5c1,0.7,2,1.1,2.7,1.5 c0.7,0.3,1.1,0.5,1.1,0.5s-0.1-0.4-0.5-1.1c-0.3-0.7-0.8-1.6-1.5-2.7c-0.2-0.3-0.3-0.6-0.5-0.8c-1.8-2.7-1.8-6.2,0-9 c0.2-0.3,0.4-0.6,0.5-0.8c0.7-1,1.1-2,1.5-2.7c0.3-0.7,0.5-1.1,0.5-1.1S328.9,190.2,328.2,190.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F1543F"
    },
    d: "M265.2,190.6c-0.7,0.3-1.6,0.8-2.7,1.5c-0.3,0.2-0.5,0.3-0.8,0.5c-2.7,1.8-6.2,1.8-9,0 c-0.3-0.2-0.6-0.4-0.8-0.5c-1-0.7-2-1.1-2.7-1.4c-0.7-0.3-1.1-0.5-1.1-0.5s0.1,0.4,0.5,1.1c0.3,0.7,0.8,1.6,1.4,2.7 c0.2,0.3,0.3,0.6,0.5,0.8c1.8,2.7,1.8,6.2,0,9c-0.2,0.3-0.4,0.6-0.5,0.8c-0.7,1-1.1,2-1.4,2.7c-0.3,0.7-0.5,1.1-0.5,1.1 s0.4-0.1,1.1-0.5c0.7-0.3,1.6-0.8,2.7-1.4c0.3-0.2,0.6-0.3,0.8-0.5c2.7-1.8,6.2-1.8,9,0c0.3,0.2,0.6,0.4,0.8,0.5 c1,0.7,2,1.1,2.7,1.5c0.7,0.3,1.1,0.5,1.1,0.5s-0.1-0.4-0.5-1.1c-0.3-0.7-0.8-1.6-1.5-2.7c-0.2-0.3-0.3-0.6-0.5-0.8 c-1.8-2.7-1.8-6.2,0-9c0.2-0.3,0.4-0.6,0.5-0.8c0.7-1,1.1-2,1.5-2.7c0.3-0.7,0.5-1.1,0.5-1.1S265.9,190.2,265.2,190.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F1543F"
    },
    d: "M328.2,238.3c-0.7,0.3-1.6,0.8-2.7,1.5c-0.3,0.2-0.5,0.3-0.8,0.5c-2.7,1.8-6.2,1.8-9,0 c-0.3-0.2-0.6-0.4-0.8-0.5c-1-0.7-2-1.1-2.7-1.4c-0.7-0.3-1.1-0.5-1.1-0.5s0.1,0.4,0.5,1.1c0.3,0.7,0.8,1.6,1.4,2.7 c0.2,0.3,0.3,0.6,0.5,0.8c1.8,2.7,1.8,6.2,0,9c-0.2,0.3-0.4,0.6-0.5,0.8c-0.7,1-1.1,2-1.4,2.7s-0.5,1.1-0.5,1.1s0.4-0.1,1.1-0.5 c0.7-0.3,1.6-0.8,2.7-1.4c0.3-0.2,0.6-0.3,0.8-0.5c2.7-1.8,6.2-1.8,9,0c0.3,0.2,0.6,0.4,0.8,0.5c1,0.7,2,1.1,2.7,1.5 c0.7,0.3,1.1,0.5,1.1,0.5s-0.1-0.4-0.5-1.1c-0.3-0.7-0.8-1.6-1.5-2.7c-0.2-0.3-0.3-0.6-0.5-0.8c-1.8-2.7-1.8-6.2,0-9 c0.2-0.3,0.4-0.6,0.5-0.8c0.7-1,1.1-2,1.5-2.7c0.3-0.7,0.5-1.1,0.5-1.1S328.9,238,328.2,238.3z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F1543F"
    },
    d: "M265.2,238.3c-0.7,0.3-1.6,0.8-2.7,1.5c-0.3,0.2-0.5,0.3-0.8,0.5c-2.7,1.8-6.2,1.8-9,0 c-0.3-0.2-0.6-0.4-0.8-0.5c-1-0.7-2-1.1-2.7-1.4c-0.7-0.3-1.1-0.5-1.1-0.5s0.1,0.4,0.5,1.1c0.3,0.7,0.8,1.6,1.4,2.7 c0.2,0.3,0.3,0.6,0.5,0.8c1.8,2.7,1.8,6.2,0,9c-0.2,0.3-0.4,0.6-0.5,0.8c-0.7,1-1.1,2-1.4,2.7c-0.3,0.7-0.5,1.1-0.5,1.1 s0.4-0.1,1.1-0.5c0.7-0.3,1.6-0.8,2.7-1.4c0.3-0.2,0.6-0.3,0.8-0.5c2.7-1.8,6.2-1.8,9,0c0.3,0.2,0.6,0.4,0.8,0.5 c1,0.7,2,1.1,2.7,1.5c0.7,0.3,1.1,0.5,1.1,0.5s-0.1-0.4-0.5-1.1c-0.3-0.7-0.8-1.6-1.5-2.7c-0.2-0.3-0.3-0.6-0.5-0.8 c-1.8-2.7-1.8-6.2,0-9c0.2-0.3,0.4-0.6,0.5-0.8c0.7-1,1.1-2,1.5-2.7c0.3-0.7,0.5-1.1,0.5-1.1S265.9,238,265.2,238.3z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E6E9EE"
    },
    d: "M125.8,378.1L125.8,378.1H89.6l0,0c0-5.4,4.4-9.7,9.7-9.7l0,0c2.7,0,4.8-2.2,4.8-4.8V180.7h7.2v182.9 c0,2.7,2.2,4.8,4.8,4.8l0,0C121.5,368.4,125.8,372.8,125.8,378.1z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#4CDBC4"
    },
    points: "146,180.7 69.4,180.7 85.3,125.5 130.1,125.5 "
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.3f57a1166fd3770e8a7301f9d0cc7fca.svg";
export { ForwardRef as ReactComponent };